import { Group, LibraryBooks } from '@mui/icons-material';
// import { TabPanel } from '@mui/lab';
import { Autocomplete, Button, Card, CardContent, Checkbox, Container, createFilterOptions, Divider, Grid, Switch, Tab, Tabs, TextField, Typography, Tooltip } from '@mui/material';
import react, { useState } from 'react';


import React, { useEffect }  from 'react';
import { useLocation } from "react-router-dom";
import Table from "../ui/Table";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import styles from './Multiple.module.scss';
import "./MultiStock.css"
import { LoadingButton } from '@mui/lab';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CompanyDataCell from '../screnner/components/CompanyDataCell';

import CustomTable from './table';
import axios from 'axios';
const login = JSON.parse(localStorage.getItem('login'))
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;



const TabPanel = ({ children, value, activeTab}) => 
    value === activeTab
      ? <div role="tabpanel" >{children}</div>
      : <></>

const tableColumnsOverlay = [
    {field:'name',headerName:'Security Name',disabled: false, hide: false,label: 'Security Name', id:'name', type: 'string',minWidth: 50,renderCell:(params)=><CompanyDataCell ticker={params.value} companyName={params.name} />},
    {field:'value',headerName:'Ticker',disabled: true, hide: false,label: 'Ticker', type: 'string', id: 'value', minWidth: 50},
    // {label: 'Correlation', id: 'correlation', type: 'number', format: (value) => `${value}%`},
    // {label: 'YoY Change', id: 'YOY', type: 'number', },z
]

const tableColumnsNowcast = [
    {label: 'Security Name', id:'name',disabled: true, hide: false, type: 'string',renderCell:(params)=><CompanyDataCell ticker={params.value} companyName={params.name}/>},
    {label: 'Ticker', type: 'string', id: 'value', },
    {label: 'Correlation', id: 'correlation', type: 'number', format: (value) => `${value}%`},
    {label: 'Abs Mean Error', id: 'abs_mean_error', type: 'number', format: (value) => `${value}%` },
]

const GroupByOptions = [
    {'label':'Daily', 'value':'daily'},
    {'label':'Weekly', 'value':'weekly'},
    {'label':'Monthly', 'value':'monthly'},
    {'label':'Quarterly', 'value':'quarterly'},
    {'label':'Annually', 'value':'yearly'},
]

const AggTypeOptions = [
    {'label':'Average', 'value':'mean'}, 
    {'label':'Sum', 'value':'sum'},
    {'label':'Minimum', 'value':'min'},
    {'label':'Maximum', 'value':'max'},
    {'label':'Last Value', 'value':'last_value'},
    {'label':'First Value', 'value':'first_value'},
]

const MultiStocks = () => {

    // const [isModalTabOpen, setisModalTabOpen] = useState(false);
    const [activeTab, setactiveTab] = useState('overlay');
    // const [testdata, setData] = useState(null);

    const [tickerData, settickerData] = React.useState([])
    const [SectorData, setSectorData] = React.useState([])
    const [IndustryList, setIndustryList] = React.useState([])
    const [ClientDatasets, setClientDatasets] = React.useState([])
    const [ActiveDatasets, setActiveDatasets] = React.useState([])

    const [KPI_ID, setKPI_ID] = React.useState(null)
    const [DatasetDescription, setDatasetDescription] = React.useState(null)
    // const [securityCategories, setSecurityCategories] = React.useState(null)
    const [selectedSector, setSelectedSector] = React.useState(null)
    const [selectedIndustry, setselectedIndustry] = React.useState(null)
    // const [selectedProvider, setSelectedProvider] = React.useState(login?.user?.client?.id)
    const [selectedProvider, setSelectedProvider] = React.useState(null)
    // const [selectedProviderName, setselectedProviderName] = React.useState(login?.user?.client?.client_name)
    const [selectedProviderName, setselectedProviderName] = React.useState(null)
    // const [selectedProviderName, setselectedProviderName] = React.useState()
    const [securityProvider, setSecurityProvider] = React.useState([])
    const [SelectedDatasetName, setSelectedDatasetName] = React.useState(null)
    const [SelectedDataset, setSelectedDataset] = React.useState(null)
    const [currency, setCurrency] = React.useState("")
    const [downloadState, setDownloadState] = React.useState(true)

    // // States related to modal form 

    const [activeTabKey, setactiveTabKey] = React.useState('overlay');
    const [isModalTabOpen, setIsModalTabOpen] = React.useState(false);
    const [allMultiSelectId, setAllMultiSelectId] = React.useState([]);
    const [valueMltSelected, setValueMltSelected] = React.useState([]);
    const [showTable, setShowTable] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [show_Nowcast_actual, setShow_Nowcast_actual] = React.useState(true);
    const [showNowcastLoader, setShowNowcastLoader] = React.useState(true);
    const [featuresList, setFeaturesList] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [dataNowcastTable, setDataNowcastTable] = React.useState([]);
    const [overlayactual, setOverlayactual] = React.useState(true);
    const [overlayModalFeatureSelected, setOverlaymodalFeatureSelected] = React.useState([]);
    const [multiSelectOption, setMultiSelectOption] = React.useState([]);
    const [SelectedDatasetFrequency, setSelectedDatasetFrequency] = React.useState('Daily');
    const [selectedOverLayKPIid, setselectedOverLayKPIid] = React.useState(null);
    const [allModalKPIs, setAllModalKPIs] = React.useState([]);
    const [NowcastingMOdalKPIs, setNowcastingMOdalKPIs] = React.useState([]);
    const [modalKPISelectedOverlay, setModalKPISelectedOverlay] = React.useState(null);
    const [modalKPISelectedNowcasting, setModalKPISelectedNowcasting] = React.useState();
    const [nowCastModalApiBreakState, setNowCastModuleApiBreakState] = React.useState(false);
    const [NowcastKPI, setNowcastKPI] = React.useState();
    const [NowcastingCheck, setNowcastingCheck] = useState(true)

    const [SelectedGroupBy, setSelectedGroupBy] = useState('')
    const [SelectedAGGtype, setSelectedAGGtype] = useState('')
    const [ColumnGranularityOptions, setColumnGranularityOptions] = useState([])


    const [overlaycolumns,setOverlaycolumns] = React.useState(tableColumnsOverlay)

    const [isdisabled, setisdisabled] = useState(false)

    
    const JSONTOCSV = data => {
        const items = data
        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
        const header = Object.keys(items[0])
        const csv = [ 
          header.join(','), // header row first
          ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
      return csv
      }


    const DownloadFile = (file, name, type = '.csv') => {
        const downloadUrl = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        let filetype = name.split('.')[1] !== ''
        link.setAttribute('download', filetype ? name + type : name); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    

    

    const getTickerData = (
        reset_search,
        sector = selectedSector,
        industry = selectedIndustry,
        provider = selectedProvider,
        dataset_id = SelectedDataset,
        provider_name = selectedProviderName,
        dataset_name = SelectedDatasetName
    ) => {
        let payload = {
            "country": industry,
            "sector": sector,
            "provider": provider ? provider : login?.user?.client?.id,
            "dataset_id": dataset_id
        }
        const queryString = Object.keys(payload)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
            .join('&');
        if (provider && SelectedDataset){
            let url = `/api/tickers/?industry=${industry}&sector=${sector}&provider=${provider}&dataset_id=${SelectedDataset}`
            if (reset_search) {
                url = `/api/analytics/stocks/search/?provider=${login?.user?.client?.id}`
            }
            // fetch(url, {
            //     method: 'GET',
            // })
            axios({
                method: 'GET',
                url: url,
            })
                .then((response) => {
                    if (!response.data) {
                        throw new Error('Network response was not ok');
                    }
                    return response.data // Parse the response body as JSON
                })
                .then((data) => {
                    if (data?.securities?.length === 0) {
                        // Show error message when no securities are available
                        // message.error(`${provider_name}'s "${dataset_name}" dataset doesn't have Fundamental Edge license`, 3.5);
                        settickerData([]);
                    } else {
                        // Set data when securities are present

                        settickerData(data);
                        // setSectorData(data?.sectors ? data.sectors.filter(x => x.security__sector__sector_name != null) : SectorData);
                        // setIndustryList(data?.country ? data.country : IndustryList);
                        setCurrency(data[0]?.reported_currency);
                    }
                })
                .catch((error) => {
                    console.error('There was a problem with the fetch operation:', error);
                    // Optionally show an error message in case of failure
                    // message.error('There Is An Internal Issue loading the Data', 2);
                })
                .finally(() => {
                    // Any final logic if needed
                });
    }

    }

    const getIndustries_Sectors = (dataset) => {

        // fetch(`/api/sector_industrylist/${ !dataset ?  SelectedDataset : dataset}`,{
        //     method: 'GET'
        // })
        axios({
            method: 'GET',
            url: `/api/sector_industrylist/${ !dataset ?  SelectedDataset : dataset}`,
        })
        .then((response)=>{
            if (!response.data) {
                throw new Error('Network response was not ok');
            }
            return response.data; // Parse the response body as JSON
        })
        .then(async (data)=>{
            let sectorDatalist = [];
            sectorDatalist = await data?.sectors?.map((item)=>{
                return(
                    {
                        label: item,
                        value: item
                    }
                )
            })
            
            let industrylist = [];
            industrylist = await data?.industries?.map((item) => {
                return(
                    {
                        label: item,
                        value: item
                    }
                )
            })
            //  
            
            setSectorData(sectorDatalist);
            setIndustryList(industrylist);
            // setSectorData(data?.sectors ? data.sectors.filter(x => x.security__sector__sector_name != null) : SectorData);
            // setIndustryList(data?.country ? data.country : IndustryList);
        }).catch((err)=>{
            console.log(err);
        })

    }

    const getProviderData = () => {
        let url = '/api/clients'
        // fetch(url, {
        //     method: 'GET',
        // })
        axios({
            method:"get",
            url: url
        })
        .then((response) => {
            if (!response.data) {
                return response.data.then((err) => {
                    throw new Error(err.message || 'There Is An Internal Issue loading the Data');
                });
            }
            return response.data; // Parsing the response body as JSON
        })
        .then((data) => {
            const formatedData = data.map((item)=>{
                return {label: item.name, value: item.althub_client_id}
            })
            setSelectedProvider(formatedData[0].value)
            setSecurityProvider(formatedData); // Use the parsed data
            setselectedProviderName(formatedData[0].label)
        })
        .catch((err) => {
            console.log(err);
            // message.error(err.message, 2);
        })
        .finally(() => {
            // Final actions (if needed)
        });
    }

    const getProvidersDetails = (client_id = selectedProvider) => {
        // fetch(`/api/active_datasets/${client_id}`, {
        //     method: 'GET',
        // })
        if (client_id){
            axios({
                method: "get",
                url: `/api/active_datasets/${client_id}`
            })
                .then((response) => {
                    if (!response.data) {
                        throw new Error('Network response was not ok');
                    }
                    return response.data; // Parsing the response as JSON
                })
                .then((data) => {                    
                    const formatedData = data.map((item)=>{
                        return {label: item.name, value: item.althub_dataset_id,description: item.description,nowcasting: item.nowcasting,frequency:item.frequency}
                    })                    
                    setActiveDatasets(data)
                    setClientDatasets(formatedData);
                    setSelectedDatasetName(formatedData[0]?.label);
                    setNowcastingCheck(formatedData[0]?.nowcasting)
                    setSelectedDataset(formatedData[0]?.value);
                    setSelectedDatasetFrequency(formatedData[0].frequency)
                })
                .catch((error) => {
                    console.error('There was a problem with the fetch operation:', error);
                })
        }
    }

    const handleChange = (sector, industry) => {
        getTickerData(false, sector, industry)
    }

    const handleChangeCmpySelect = (value,e) => {
         
        if(e.length != 0){
            if(e[e.length-1].value == 'Select All'){
                const AllValues = multiSelectOption.slice(1,multiSelectOption.length-1);
                setValueMltSelected(AllValues)
                var numbersArray = AllValues.map(function (element) {
                    var numbers = element.value.match(/\) (\d+)$/);
                    return numbers ? parseInt(numbers[1], 10) : null;
                });
                setAllMultiSelectId(numbersArray)  
                //  
            }else{
                setValueMltSelected(e)
                var numbersArray = e.map(function (element) {
                    var numbers = element.value.match(/\) (\d+)$/);
                    return numbers ? parseInt(numbers[1], 10) : null;
                });
                setAllMultiSelectId(numbersArray)
            }
        }else{
            setValueMltSelected([])
            setAllMultiSelectId([]);
        }
        //  
    };

    const downloadCsvDataHandler = (el, v, modalKpi_id, datasetid) => {
        setDownloadState(false)
        if (activeTabKey == "overlay") {
            var formattedArray = data.map(item => {
                let tempdata = {}
                tempdata.SecurityName = item.name.replace(/_/g, ' ');
                tempdata.Ticker = item.value.replace(/_/g, ' ');
                overlaycolumns.map(col=>{
                    if (!['Security Name','Ticker'].includes(col['label'])){
                        tempdata[col['label']] = item[col['id']]
                    }
                })
                return tempdata
                // return {
                //     "SecurityName": item.name.replace(/_/g, ' '),
                //     "Ticker": item.value.replace(/_/g, ' '),
                //     "Correlation": `${item.correlation}%`,
                //     "AbsMeanError": `${item.abs_mean_error}%`,
                // };
            });
            let file_name = ''
            if (overlayactual){
                file_name = "Overlay-MultiStock_Analysis_Actual_Data"
            }
            else{
                file_name = "Overlay-MultiStock_Analysis_Percentage_Change_Data"
            }
            DownloadFile(JSONTOCSV(formattedArray), file_name);
            setDownloadState(true)
        } else {
            var formattedArray = dataNowcastTable.map(item => {
                return {
                    "SecurityName": item.name.replace(/_/g, ' '),
                    "Ticker": item.value.replace(/_/g, ' '),
                    "Correlation": `${item.correlation}%`,
                    "AbsMeanError": `${item.abs_mean_error}%`,
                };
            });

            let file_name = ''
            if (show_Nowcast_actual){
                file_name = "Nowcasting-MultiStock_Analysis_Actual_Data"
            }
            else{
                file_name = "Nowcasting-MultiStock_Analysis_Percentage_Change_Data"
            }
            DownloadFile(JSONTOCSV(formattedArray), file_name);
            setDownloadState(true)
        }
    }

    const handleModalApplyBtn = () => {
        let url = `/api/clients_kpis/${selectedProvider}`
        // fetch(url, {
        //     method: 'GET',
        // })
        axios({
            method: 'GET',
            url: url,
        })
            .then((response) => {
                if (!response.data) {
                    throw new Error('Network response was not ok');
                }
                return response.data; // Parse the response body as JSON
            })
            .then((data) => {                
                if (data[0]?.value) {
                    // Filter and set KPI data
                    let Temp = data.filter(x => x.name == 'Revenue');
                    Temp = Temp.map((x)=>{return({label:x.name,value:x.value})})
                    
                    setNowcastingMOdalKPIs(Temp);
                    const formatedKpiData = data.map((x)=> {return({label: x.name, value: x.value})})
                    setAllModalKPIs(formatedKpiData);
                    setModalKPISelectedOverlay(data[0]['id']);
                    const tempData = ActiveDatasets.filter(data=> data.value === SelectedDataset)
                    setNowcastingCheck(tempData[0]?.nowcasting)
                    setselectedOverLayKPIid(data[0]['id']);
                    setKPI_ID(data[0]['id']);
                }
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
            });
        


        if (allMultiSelectId.length !== 0) {
            setIsModalTabOpen(true);
            setShowTable(false);
            setShowLoader(false);
            setactiveTabKey('overlay');
            setactiveTab('overlay');
            setOverlaymodalFeatureSelected([])

        } else {
            setIsModalTabOpen(true);
            setShowTable(false);
            setShowLoader(false);
            setactiveTabKey('overlay');
            setactiveTab('overlay');
            setOverlaymodalFeatureSelected([])
            var numbersArray = multiSelectOption.map(function (element) {
                var numbers = element.value.match(/\) (\d+)$/);
                return numbers ? parseInt(numbers[1], 10) : null;
            });

            setAllMultiSelectId(numbersArray)
        }
    }
    
    const handleTabChange = (v, actulValue, feature, modalKPISelectedNowcasting, groupby_method = SelectedGroupBy, agg_type = SelectedAGGtype) => {
        setactiveTab(v);
        setShowNowcastLoader(true)
        setactiveTabKey(v);
        if (v == "nowcasting") {
            const url = "/api/now-casting-multistock-analysis"
            const obj = {
                client_id: selectedProvider,
                kpi_id: NowcastKPI,
                reference_name: "total_revenue",
                security_id: allMultiSelectId,
                dataset_id: SelectedDataset,
                data_type: actulValue ? "actual" : "pct_change"
            }
            let filterdata = tickerData.filter((item) => {
                return allMultiSelectId.includes(item.althub_security_id)
            })
            // fetch(`${url}`, {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'  // Ensure the content type is set correctly
            //     },
            //     body: JSON.stringify(obj)  // Convert the object to a JSON string
            // })
            axios({
                method: 'POST',
                url: url,
                data: obj,
            })
                .then((response) => {
                    if (!response.data) {
                        throw new Error('Network response was not ok');
                    }
                    return response.data;  // Parse the response body as JSON
                })
                .then((data) => {
                    if (data.length !== 0) {
                        data.forEach(resDataItem => {
                            var matchingElement = filterdata.find(filteredItem => filteredItem.althub_security_id === resDataItem.security_id);
            
                            if (matchingElement) {
                                // Update correlation and abs_mean_error with percentage values
                                matchingElement.correlation = `${resDataItem.correlation}%`;
                                matchingElement.abs_mean_error = `${resDataItem.abs_mean_error}%`;
                            }
                        });
                    }
                    setDataNowcastTable(filterdata);  // Update the table data
                    setShowNowcastLoader(false);  // Stop the loader
                })
                .catch((error) => {
                    console.error('There was a problem with the fetch operation:', error);
                    setNowCastModuleApiBreakState(true);  // Handle API break state
                    // message.error("client_id is required to perform this action");  // Display error message
                });
        } else if (v == "overlay") {
            setData([])
            let TempAggOptions = []
            if (feature.length >1){
                TempAggOptions = feature.map(item=>{
                    const agg = ColumnGranularityOptions.filter(item => item.dataset_name == SelectedDatasetName).filter(item => item.kpi_name==modalKPISelectedNowcasting).filter(x=>x.column == item.value)[0]
                    return{
                        "column":item?.value,
                        "agg_type":agg?.agg_method
                        }
                    })
                }
            const url = "/api/multistock-analysis";
            if (SelectedDatasetFrequency.toLowerCase() == groupby_method ){
                agg_type = "sum"
            }
            const obj = {
                client_id: selectedProvider,
                feature_name: feature,
                kpi_id: modalKPISelectedNowcasting,
                reference_name: modalKPISelectedNowcasting == 'revenue' ? "total_revenue" : modalKPISelectedNowcasting,
                security_id: allMultiSelectId,
                dataset_id: SelectedDataset,
                groupby_method : groupby_method,
                agg_type : groupby_method != 'daily'?agg_type:'',
                data_type: actulValue ? "actual" : "pct_change",
                agg_func: TempAggOptions
            }
            if (feature != undefined && feature.length !=0 && agg_type && groupby_method && modalKPISelectedNowcasting ) {
                setShowTable(true);
                setShowLoader(false);

                let filterdata = tickerData.filter((item) => {
                    return allMultiSelectId.includes(item.althub_security_id)
                })
                // fetch(url, {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify(obj)  // Convert the object to a JSON string
                // })
                axios({
                    method: 'POST',
                    url: url,
                    data: obj,
                })
                    .then((response) => {
                        if (!response.data) {
                            throw new Error('Network response was not ok');
                        }
                        return response.data;  // Parse the response body as JSON
                    })
                    .then((data) => {
                        if (data.length !== 0) {
                            let mainData = []
                            data.forEach((resDataItem,i) => {
                                var matchingElement = filterdata.find(filteredItem => filteredItem.althub_security_id === resDataItem.security_id);
                                mainData.push({...resDataItem,...matchingElement,id:i});
                                setData(mainData);
                            });
                        }
                        else{
                            setData([])
                        }
                        setShowLoader(true);
                        setisdisabled(false)
                    })
                    .catch((error) => {
                        console.error('There was a problem with the fetch operation:', error);
                        setShowTable(false);
                        setisdisabled(false)
                    })
                    .finally(() => {
                        // Any final logic can go here if needed
                    });
            }
        }
    }

    const handleOverlaySwitcherChange = (v) => {
        if (overlayModalFeatureSelected != undefined) {
            setOverlayactual(v);
            handleTabChange("overlay", v, overlayModalFeatureSelected, modalKPISelectedOverlay);
        } else {
            setOverlayactual(v);
        }
    }

    const handleOverlayFeatureChange = (v,e,{selected}) => {
         
        if(e.length != 0){
            if(e[e.length-1].value == "Select All"){
                //  
                const values = featuresList.slice(1,featuresList.length-1);
                setOverlaymodalFeatureSelected(values);
                handleTabChange("overlay", overlayactual ? true : false, values, modalKPISelectedOverlay);
            }else{
                setOverlaymodalFeatureSelected(e);
                handleTabChange("overlay", overlayactual ? true : false, e, modalKPISelectedOverlay);
            }
        }else{
            setOverlaymodalFeatureSelected([]);
        }
    }

    useEffect(()=>{
        const Tempdata = ActiveDatasets?.filter(item=> item.althub_dataset_id==SelectedDataset)
        if (Tempdata.length>0){
            const featureData = Tempdata[0]['columns'].map(col=>{
                return {label: col.name, value: col.value,description: col.description}
            })
            setFeaturesList(featureData)
        }
        getTickerData(false)
        return () => {}
    },[SelectedDataset])

    React.useEffect(() => {
        if (ClientDatasets.length > 0) {
            if (selectedProviderName != null) getIndustries_Sectors();
            ClientDatasets.map((x) => {
                if (x.value == SelectedDataset) {
                    setDatasetDescription({ "name": x?.label ? x?.label : '', "description": x.description ? x.description : '' })
                    if (selectedProviderName != null) setSelectedDatasetName(x.label)
                }
            })
        }
        return () => {}
        // getProvidersDetails()
    }, [selectedProviderName, SelectedDataset])

    useEffect(()=>{
        getProvidersDetails();
        return () => {}
    },[selectedProviderName])

    useEffect(() =>{
        (async () => {
            const resJson = await axios.get(`/api/getColumnGranularityOptions`)
            const res = await resJson.data
            setColumnGranularityOptions(res)
        })()
        return () => setColumnGranularityOptions()
        },[])

    useEffect(() => {
        // if (login) getProvidersDetails()
        getProviderData()
        return () => {}
    }, [])


    React.useEffect(() => {
        const options = [];
        tickerData.map((x) => {
            options.push({
                label: `${x.name} (${x.value})`,
                value: `${x.name} (${x.value}) ${x.althub_security_id}`,
            })
        })
        setMultiSelectOption(options);
        return () => {}
    // }, [modalTickerData, tickerData])
    }, [ tickerData])

    useEffect(() => {
        if (selectedProvider != null) {
            let url = `/api/clients_kpis/${selectedProvider}`

            // fetch(url, {
            //     method: 'GET'
            // })
            axios.get(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json(); // Parse the response body as JSON
                })
                .then((data) => {
                    let Temp = data.filter(x => x.name == 'Revenue');
                    Temp = Temp.map((x)=>{return({label:x.name,value:x.value})}) 
                    setNowcastingMOdalKPIs(Temp);
                    setModalKPISelectedNowcasting(Temp[0]?.value);
                    setNowcastKPI(Temp[0]?.value);
                })
                .catch((error) => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }
        return () => {}
    }, [activeTabKey, selectedProvider])


    const adminTabs = [
        <Tab label="Overlay" value="overlay" key="overlay" classes={{ root: styles['tab'], selected: styles['selected'] }}/>,
        NowcastingCheck&&<Tab label="Nowcasting (Beta Version)" value="nowcasting" key="nowcasting" classes={{ root: styles['tab'], selected: styles['selected'] }}/>,
        // <Tab label={<button>click</button>} style={{width:"100%"}}></Tab>
    ]

    const adminTabsPanel = [
        <TabPanel value="overlay" activeTab={activeTab} key="overlay">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div className="select-div" style={{alignItems:"end"}}>                        
                    <Autocomplete
                        className="data-select"
                        size='small'
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        value={allModalKPIs.find(option => option.value === modalKPISelectedOverlay) || null}
                        options={allModalKPIs}
                        renderInput={(params) => <TextField {...params} label='Standard Financial KPIs' />}
                        onChange={(v, e) => { 
                            setModalKPISelectedOverlay(e.value); 
                            const temp = ColumnGranularityOptions.filter(item=>item.dataset_name== SelectedDatasetName).filter(item => item.kpi_name==e.value)
                            setSelectedGroupBy(temp[0]?.group_by)
                            handleTabChange("overlay", overlayactual, overlayModalFeatureSelected, e.value) }}
                    />
                    {modalKPISelectedOverlay && <Autocomplete
                        multiple
                        className="data-select"
                        size='small'
                        disablePortal
                        id="disable-clearable"
                        limitTags={2}
                        disableCloseOnSelect
                        value={overlayModalFeatureSelected}
                        filterOptions={(options, params) => { // <<<--- inject the Select All option
                            const filter = createFilterOptions()
                            const filtered = filter(options, params)
                            if (filtered.length>0){return [{ label: `Select All... (${featuresList.length})`, all: true }, ...filtered]}
                            else{ return[] }
                          }}
                        options={featuresList}
                        getOptionLabel={option => option.label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                        renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            //  
                            return (
                                <Tooltip style={{backgroundColor:'transparent'}} key={option.label} title={option.description} placement="right" arrow>
                                    <li key={key} {...optionProps}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={option.all ? !!(overlayModalFeatureSelected.length === featuresList.length) : selected}
                                    />
                                    {option.label}
                                    </li>
                                
                                </Tooltip>
                            );
                            }}
                        disabled={isdisabled}
                        renderInput={(params) => <TextField {...params} label='+ Add Alternative KPI' />}
                        onChange={(event, newValue) => {
                            if (newValue.find(option => option.all))setisdisabled(true)
                            if (newValue.length>1)setisdisabled(true)
                            // const tempColumnGranularityOptions = ColumnGranularityOptions.filter(item => item.dataset_name == SelectedDatasetName).filter(item => item.kpi_name==modalKPISelectedOverlay)
                            if (newValue.find(option => option.all)) {
                                setSelectedAGGtype('multiple')
                                const updatedFeatures = overlayModalFeatureSelected.length === featuresList.length ? [] : featuresList;
                                setOverlaymodalFeatureSelected(updatedFeatures);
                                handleTabChange("overlay", overlayactual, updatedFeatures, modalKPISelectedOverlay,SelectedGroupBy,'multiple');
                                const selectcols = updatedFeatures.map(x=>{return{
                                    field:x.value,
                                    headerName:x.label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                                    editable: true,
                                    label:x.label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                                    id:x.value,
                                    type: 'number', 
                                    minWidth:50,
                                    format: (value) => `${value}%`,
                                }})
                                setOverlaycolumns([...tableColumnsOverlay,...selectcols])
                            } else {
                                setisdisabled(false)
                                let agg_metod = null
                                if (newValue.length>1){
                                    agg_metod = 'multiple'
                                    setSelectedAGGtype('multiple')
                                }
                                if (newValue.length>0){
                                    const selectcols = newValue.map(x=>{return{
                                        field:x.value,
                                        headerName:x.label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                                        editable: true,
                                        label:x.label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                                        id:x.value,
                                        type: 'number', 
                                        minWidth:170,
                                        format: (value) => `${value}%`,
                                    }})
                                    setOverlaycolumns([...tableColumnsOverlay,...selectcols])
                                }
                                else{setOverlaycolumns([])}
                                setData([])
                                setOverlaymodalFeatureSelected(newValue);
                                handleTabChange("overlay", overlayactual, newValue, modalKPISelectedOverlay,SelectedGroupBy,agg_metod);
                            }
                        }}
                    />}
                    {modalKPISelectedOverlay && overlayModalFeatureSelected.length>=1&&<Autocomplete
                        className="data-select"
                        size='small'
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        value={GroupByOptions.find(option => option.value === SelectedGroupBy) || null}
                        getOptionDisabled={(option) => {
                            // Disable options based on the frequency value                            
                            if (SelectedDatasetFrequency == 'Weekly' && (option.value === 'daily')) {
                                return true;
                                }
                            if (SelectedDatasetFrequency == 'Monthly' && (option.value === 'daily' || option.value === 'weekly')) {
                                return true;
                            }
                            if (SelectedDatasetFrequency == 'Quarterly' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly')) {
                                return true;
                            }
                            if (SelectedDatasetFrequency == 'Biannually' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly' || option.value === 'quarterly')) {
                                return true;
                            }
                            if (SelectedDatasetFrequency == 'Yearly' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly' || option.value === 'quarterly' || option.value === 'biannually')) {
                                return true;
                            }
                            // Add more conditions based on the frequency value as needed
                            return false;
                            }}
                        options={GroupByOptions}
                        renderInput={(params) => <TextField {...params} label='Group By' />}
                        // onChange={(event, newValue) => {setSelectedGroupBy(newValue.value)}}
                        onChange={(event, newValue) => { setSelectedGroupBy(newValue.value); handleTabChange("overlay", overlayactual, overlayModalFeatureSelected, modalKPISelectedOverlay, newValue.value, SelectedAGGtype) }}
                    />}
                    {SelectedDatasetFrequency.toLowerCase() != SelectedGroupBy&&
                    <>
                    {modalKPISelectedOverlay && overlayModalFeatureSelected.length==1 && SelectedGroupBy && SelectedGroupBy != "daily" &&
                    <Autocomplete
                        className="data-select"
                        size='small'
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        value={AggTypeOptions.find(option => option.value === SelectedAGGtype) || null}
                        options={AggTypeOptions}
                        renderInput={(params) => <TextField {...params} label='Aggregation By' />}
                        // onChange={(event, newValue) => {setSelectedAGGtype(newValue.value)}}
                        onChange={(event, newValue) => { setSelectedAGGtype(newValue.value); handleTabChange("overlay", overlayactual, overlayModalFeatureSelected, modalKPISelectedOverlay ,SelectedGroupBy,newValue.value) }}
                    />}

                    {modalKPISelectedOverlay && overlayModalFeatureSelected.length>1&& SelectedGroupBy && SelectedGroupBy != SelectedDatasetFrequency.toLowerCase()&&
                        <Tooltip arrow placement='top' title={
                            "You have selected multiple alternative KPIs which are aggregated differently by default. Please select only one alternative KPI to change the default aggregation type"
                        }><Autocomplete
                            disabled
                            className="data-select-1"
                            size='small'
                            options={{label:'Multiple',value:'multipe'}}
                            defaultValue={{label:'Multiple',value:'multipe'}}
                            value={'Multiple'}
                            renderInput={(params) => <TextField {...params} label="Aggregation By" />}
                        /></Tooltip>}
                        </>}
                </div>
                
                <div style={{display:"flex",alignItems:"center"}}>
                    <Typography>% Change</Typography>
                    <Switch 
                        checked={overlayactual}
                        defaultValue={true}
                        // color='#dccb03'
                        onChange={(v,e) => {
                            handleOverlaySwitcherChange(e)
                        }}
                    />
                    <Typography>Actual</Typography>
                </div>
            </div>
            {/* <Divider style={{marginTop:"20px"}}/> */}

            <div style={{marginTop:"20px"}}>
                {showTable ? showLoader ? 
                <CustomTable columns={overlaycolumns} rows={data} Theader={true}  showLoader={showLoader}/>
                : <CustomTable columns={overlaycolumns}   Theader={true} rows={[]} showLoader={showLoader}/> : "" }
            </div>

        </TabPanel>,
        <TabPanel value="nowcasting" activeTab={activeTab} key="nowcasting">
            {/* <ManageDatasets/> */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div className="select-div" style={{alignItems:"end"}}>                        
                    <Autocomplete
                        className="data-select"
                        size='small'
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        defaultValue={NowcastingMOdalKPIs[0]}
                        options={NowcastingMOdalKPIs}
                        getOptionLabel={(option) =>  option.label}
                        renderInput={(params) => <TextField {...params} label='Standard Financial KPIs' />}
                        onChange={(v, e) => {  setModalKPISelectedNowcasting(e); handleTabChange("nowcasting", show_Nowcast_actual, overlayModalFeatureSelected, v) }}
                    />
                </div>
                <div style={{display:"flex",alignItems:"center"}}>
                    <Typography>% Change</Typography>
                        <Switch
                            defaultValue={true}
                            checked={show_Nowcast_actual}

                            onChange={(v,e) => {
                                setShow_Nowcast_actual(e);
                                handleTabChange("nowcasting", e, overlayModalFeatureSelected, modalKPISelectedNowcasting);
                            }}
                        />
                    <Typography>Actual</Typography>
                </div>
            </div>

            <Divider style={{marginTop:"20px"}}/>

            <div style={{marginTop:"20px"}}>
                {
                    showNowcastLoader ? nowCastModalApiBreakState 
                    ? "" : <CustomTable  columns={tableColumnsNowcast} rows={[]} Theader={false}/> 
                    :
                        <CustomTable  columns={tableColumnsNowcast} rows={dataNowcastTable} Theader={false}/>
                }
            </div>

        </TabPanel>,
    ]


    return (
        <>
            <Card  className="news-crd" style={{margin: "30px 15px 0px 15px"}}>
                <CardContent>
                        <Grid container spacing={3} style={{marginTop:"10px",justifyContent:"space-around"}}>
                            <Grid  xs={2}>
                                <Autocomplete
                                    className="data-select"
                                    size='small'
                                    disablePortal
                                    id="disable-clearable"
                                    disableClearable
                                    value={selectedProviderName}
                                    fullWidth
                                    options={securityProvider}
                                    renderInput={(params) => <TextField {...params} label='Choose a Provider' />}
                                    onChange={(v, e) => {
                                        if (e) {
                                            setIndustryList([]);
                                            setSectorData([]);
                                            settickerData([]);
                                            setClientDatasets([])
                                            setValueMltSelected([])
                                            setSelectedDatasetName(null)
                                            setSelectedSector(null);
                                            setselectedIndustry(null);
                                            setSelectedProvider(e.value);
                                            getProvidersDetails(e.value);
                                            setselectedProviderName(e.label);
                                        } else {
                                            setSelectedDatasetName(null);
                                            setIndustryList([]);
                                            setSectorData([]);
                                            settickerData([]);
                                            setClientDatasets([])
                                            setSelectedProvider(null);
                                            setselectedProviderName(null);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid  xs={2}>
                                <Autocomplete
                                    className="data-select"
                                    size='small'
                                    disablePortal
                                    id="disable-clearable"
                                    disableClearable
                                    fullWidth
                                    value={SelectedDatasetName}
                                    options={ClientDatasets}
                                    renderInput={(params) => <TextField {...params} label='Choose a Dataset' />}
                                    onChange={(v, e) => {
                                        if (v) {
                                            const dataset = ActiveDatasets.filter(activeDataset => activeDataset.value === e.value)
                                            setIndustryList([])
                                            setSectorData([])
                                            settickerData([])
                                            setSelectedSector(null)
                                            setValueMltSelected([])
                                            setselectedIndustry(null)
                                            setSelectedDataset(e.value)
                                            setSelectedDatasetName(e.label)
                                            getIndustries_Sectors(e.value);
                                            setSelectedDatasetFrequency(e.frequency)
                                            // getTickerData(false,null,null,selectedProvider,e.value,selectedProviderName,e.value)
                                        } else {
                                            setIsModalTabOpen(false)
                                            setIndustryList([])
                                            setSectorData([])
                                            settickerData([])
                                            setValueMltSelected([])
                                            setSelectedDataset(null)
                                            setSelectedDatasetName(null)
                                            setSelectedDatasetFrequency(null)
                                        }

                                    }}
                                />
                            </Grid>
                            {/*<Grid  xs={2}>
                                {IndustryList.length > 0 &&
                                    <Autocomplete
                                        className="data-select"
                                        size='small'
                                        disablePortal
                                        id="disable-clearable"
                                        options={IndustryList}
                                        renderInput={(params) => <TextField {...params} label='Choose an Industry' />}
                                        value={selectedIndustry}
                                        onChange={(v, e) => {
                                            if (e != null) {
                                                setselectedIndustry(e?.value ?  e.value : null)
                                                setValueMltSelected([])
                                                handleChange(selectedSector ? selectedSector : null, e?.value)
                                            } else {
                                                setselectedIndustry(null)
                                                setValueMltSelected([])
                                                handleChange(selectedSector ? selectedSector : null, null)
                                            }
                                        }}
                                    />
                                }
                            </Grid> */}
                            <Grid  xs={2}>
                                {SectorData.length > 0 &&
                                    <Autocomplete
                                        className="data-select"
                                        size='small'
                                        disablePortal
                                        id="disable-clearable"
                                        fullWidth
                                        options={SectorData}
                                        renderInput={(params) => <TextField {...params} label='Choose a Sector' />}
                                        value={selectedSector}
                                        onChange={(v, e) => {
                                            if (e != null) {
                                                setSelectedSector(e.value)
                                                setValueMltSelected([])
                                                handleChange(e.value, selectedIndustry ? selectedIndustry : null)
                                            } else {
                                                setSelectedSector(null)
                                                setValueMltSelected([])
                                                handleChange(null, selectedIndustry ? selectedIndustry : null)
                                            }
                                        }}
                                        
                                    />
                                }
                            </Grid>
                            <Grid xs={2}>
                                { IndustryList.length > 0 &&
                                    <Autocomplete
                                        multiple
                                        className="data-select"
                                        size='small'
                                        disablePortal
                                        id="disable-clearable"
                                        limitTags={4}
                                        fullWidth
                                        disableCloseOnSelect
                                        value={valueMltSelected}
                                        filterOptions={(options, params) => { // <<<--- inject the Select All option
                                            const filter = createFilterOptions()
                                            const filtered = filter(options, params)
                                            if (filtered.length>0){return [{ label: `Select All... (${multiSelectOption.length})`, all: true }, ...filtered]}
                                            else{ return[] }
                                            // return [{ label: 'Select All...', all: true }, ...filtered]
                                          }}
                                        options={multiSelectOption}
                                        renderOption={(props, option, { selected }) => {
                                            const { key, ...optionProps } = props;
                                            //  
                                            return (
                                              <li key={key} {...optionProps}>
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                //   checked={selected}
                                                  checked={option.all ? !!(valueMltSelected.length === multiSelectOption.length) : selected}

                                                />
                                                {option.label}
                                              </li>
                                            );
                                          }}
                                        renderInput={(params) => <TextField {...params} label='Search for Company' />}
                                        onChange={(event, newValue) => {
                                            if (newValue.find(option => option.all)){
                                                const updatedFeatures = valueMltSelected.length === multiSelectOption.length ? [] : multiSelectOption;
                                                setValueMltSelected(updatedFeatures)
                                                var numbersArray = updatedFeatures.map(function (element) {
                                                    var numbers = element.value.match(/\) (\d+)$/);
                                                    return numbers ? parseInt(numbers[1], 10) : null;
                                                });
                                                setAllMultiSelectId(numbersArray)  
                                            }else{
                                                setValueMltSelected(newValue)
                                                var numbersArray = newValue.map(function (element) {
                                                    var numbers = element.value.match(/\) (\d+)$/);
                                                    return numbers ? parseInt(numbers[1], 10) : null;
                                                });
                                                setAllMultiSelectId(numbersArray)  
                                            }
                                      
                                          }}
                                    />
                                }
                            </Grid>
                            <Grid xs={1}>
                                <Button size="medium" disabled={valueMltSelected.length === 0} className={valueMltSelected.length === 0 ? styles['dis'] : styles['applyBtn']} onClick={handleModalApplyBtn} type="submit" value="Submit" variant="contained" color="primary" style={{float:"right",color:""}}>
                                    Apply
                                </Button>
                            </Grid>
                        </Grid>                        
                </CardContent>
                
                {
                    isModalTabOpen && (
                        <>
                        <Divider/>
                        <CardContent>
                            <Tabs 
                                value={activeTab} 
                                classes={{ indicator: styles['indicator'] }}
                                onChange={(v,e) => { handleTabChange(e, e == "overlay" ? overlayactual ? true : false : show_Nowcast_actual ? true : false, overlayModalFeatureSelected, v == "overlay" ? modalKPISelectedOverlay : modalKPISelectedNowcasting) }}
                            >
                                {adminTabs}
                                <div style={{width:"100%",display:"flex",justifyContent:"end",marginRight:"30px",padding: "10px 0px"}}>
                                    <LoadingButton
                                        size="small"
                                        onClick={downloadCsvDataHandler}
                                        className={ !downloadState ? styles['disabledBtn'] : styles['applyBtn']}
                                        // endIcon={<SendIcon />}
                                        startIcon={<FileDownloadOutlinedIcon/>}
                                        loading={!downloadState}
                                        loadingPosition="start"
                                        variant="contained"
                                        disabled={!downloadState}
                                    >
                                        {downloadState ? "Download Excel" : "Downloading..."}
                                    </LoadingButton>
                                </div>    
                            </Tabs>
                            {/* <Container maxWidth="lg"> */}
                                <CardContent style={{marginTop:"20px"}}>
                                    {adminTabsPanel}
                                </CardContent>
                            {/* </Container> */}
                        </CardContent>
                        </>
                    )
                }
                
            </Card>
        </>
    )
}

export default MultiStocks